import React from 'react';

import { AudienceCard } from '../modules/audience-card';
import { CategoryDashboard } from '../modules/audience-category-dashboard';

const sortingOptions = [
    {
        label: 'Sort by: Name',
        value: 'name',
        direction: 'asc',
    },
    {
        label: 'Sort by: Newest',
        value: '_created',
        direction: 'desc',
    },
    {
        label: 'Sort by: Last Updated',
        value: 'lastRefreshed',
        direction: 'desc',
    },
];

const AdobeLayout = ({
    audienceSegments,
    onSearch,
    segmentCount,
    activeAudience,
    organizationId,
}) => {
    const linkToAudienceTab = {
        pathname: '/audiences/all',
        query: { audienceTab: 'advertiser_data' },
        linkBackLabel: 'Advertiser Data',
    };

    return (
        <CategoryDashboard
            audienceSegments={audienceSegments}
            onSearch={onSearch}
            segmentCount={segmentCount}
            activeAudience={activeAudience}
            organizationId={organizationId}
            sortingOptions={sortingOptions}
            description={
                'Integrating first-party data via Adobe Audience Manager, this segment activates known customer and pre-defined audience groups.'
            }
            title={'Adobe Audience Manager'}
            linkToAudienceTab={linkToAudienceTab}
            bannerImagePath={'/images/audience-segments/banners/adobe-banner.png'}
            renderAudienceCard={segment => (
                <AudienceCard
                    segment={segment}
                    active={segment.id === activeAudience}
                    organizationId={organizationId}
                />
            )}
        />
    );
};

export default AdobeLayout;
